module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-reviews-content"
  }, [_c('div', {
    staticClass: "custom-reviews-content__container"
  }, [(_vm.location == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__location"
  }, [_c('h2', {
    staticClass: "custom-reviews-content__location-header"
  }, [_vm._v("Let Us Know What You Think!")]), _c('br'), _c('div', {
    staticClass: "custom-reviews-content__location-title"
  }, [_vm._v("Choose Your Location")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#8EC83F'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("las")
      }
    }
  }, [_vm._v("Chenin Orthodontic Group - Henderson")]), _c('a', {
    staticClass: "custom-reviews-content__location-button",
    style: ({
      'background': '#006f51'
    }),
    on: {
      "click": function($event) {
        _vm.isLocation("chen")
      }
    }
  }, [_vm._v("Chenin Orthodontic Group - Summerlin")])]) : _vm._e(), (_vm.location == "las") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#8EC83F'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#E6A30D'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/chenin-orthodontic-group-henderson",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/CheninOrtho",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?client=safari&rls=en&q=chenin+orthodontic+group&ie=UTF-8&oe=UTF-8#lrd=0x80c8ce073c3a6211:0xc4f7872cd2620abf,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google")])]) : _vm._e()]) : _vm._e(), (_vm.location == "chen") ? _c('div', {
    staticClass: "custom-reviews-content__location-wrap"
  }, [(_vm.yelper == "unknown") ? _c('div', {
    staticClass: "custom-reviews-content__yelper-buttons"
  }, [_c('img', {
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-logo.png",
      "alt": "yelp-logo"
    }
  }), _c('h1', [_vm._v("Are you a Yelper?")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#8EC83F'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("yes")
      }
    }
  }, [_vm._v("YES")]), _c('a', {
    staticClass: "custom-reviews-content__yelper-button",
    style: ({
      'background': '#E6A30D'
    }),
    on: {
      "click": function($event) {
        _vm.isYelper("no")
      }
    }
  }, [_vm._v("NO")])]) : _vm._e(), (_vm.yelper == "yes") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#a0251e'
    }),
    attrs: {
      "href": "https://www.yelp.com/biz/chenin-and-thalgott-orthodontics-las-vegas",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/yelp-square.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Yelp")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#2d417a'
    }),
    attrs: {
      "href": "https://www.facebook.com/CheninandThalgottOrthodontics",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/fb_icon.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Facebook")])]) : _vm._e(), (_vm.yelper == "no") ? _c('a', {
    staticClass: "custom-reviews-content__button",
    style: ({
      'background': '#e5a30e'
    }),
    attrs: {
      "href": "https://www.google.com/search?q=chenin+orthodontic+thalgott&client=safari&rls=en&ei=ZvnrY77TKPrCkPIPt4G_wAU&ved=0ahUKEwi-nrvy9pX9AhV6IUQIHbfAD1gQ4dUDCBA&uact=5&oq=chenin+orthodontic+thalgott&gs_lcp=Cgxnd3Mtd2l6LXNlcnAQAzIFCCEQoAEyBQghEKABMgUIIRCgATIFCCEQoAE6CggAEEcQ1gQQsAM6DQgAEEcQ1gQQyQMQsAM6CAgAEJIDELADOgIIJjoLCCEQFhAeEPEEEB1KBAhBGABKBAhGGABQuQdY4w5g0w9oAnABeACAAa4BiAHABZIBAzcuMZgBAKABAcgBCcABAQ&sclient=gws-wiz-serp#lrd=0x80c8bfe16b03445d:0xa5e56ccf7bfc2cee,3,,,,",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "custom-reviews-content__social-icon",
    attrs: {
      "src": "https://lvosmiles.com/wp-content/uploads/new-google-favicon-512.png"
    }
  }), _c('div', {
    staticClass: "custom-reviews-content__text"
  }, [_vm._v("Review us on Google ")])]) : _vm._e()]) : _vm._e()]), (_vm.location == "chen" || _vm.location == "las") ? _c('h3', [_vm._v("If you have not written more than 10 reviews on Yelp, "), _c('br', {
    staticClass: "custom-reviews-content__br"
  }), _vm._v("please click “No” to submit a Google or Facebook review.        ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3beb1ac","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-reviews-content/custom-reviews-content.pug
// module id = 673
// module chunks = 1